const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Constants = {
  BACKEND_URL
};

export default Constants;